// aos js
AOS.init({
  duration: 1200,
});
// mobile version
AOS.init({disable: 'mobile'});
	AOS.init({
	disable: function() {
	  var maxWidth = 991;
	  return window.innerWidth < maxWidth;
	}
});

// sticky header
$(window).scroll(function(){
  var sticky = $('.header-wrapper'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('sticky');
  else sticky.removeClass('sticky');
});

// banner slider js

$('#banner-slider').slick({
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 7000,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-angle-up"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-angle-down"></i></button>',
  //infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$('#clientstel-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-angle-up"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-angle-down"></i></button>',
  //infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "10%",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

/*## popular product js*/ 
$('#shop-rings-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  //infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

/*## popular product js*/ 
$('#popular-product-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  //infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

// testmonials slider js
$('#testmonials-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow:"<button type='button' class='slick-prev'><i class='fa-solid fa-angle-left'></i></button>",
  nextArrow:"<button type='button' class='slick-next'><i class='fa-solid fa-angle-right'></i></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$('#top-head-slider').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 0,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-angle-up"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-angle-down"></i></button>',
  //infinite: false,
  speed: 12000,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


/*#####*/ 

// const crewMembers = [
//   { name: "Alex Carter", role: "CEO" },
//   { name: "Sofia Lee", role: "Design Lead" },
//   { name: "Ryan Mitchell", role: "Full Stack Developer" },
//   { name: "Chloe Morgan", role: "Marketing Head" },
//   { name: "Daniel Smith", role: "Project Manager" },
//   { name: "Mia Johnson", role: "Content Strategist" }
// ];

const crewCards = document.querySelectorAll(".crew-card");
const crewDots = document.querySelectorAll(".crew-dot");
const crewName = document.querySelector(".crew-name");
const crewRole = document.querySelector(".crew-role");
const leftBtn = document.querySelector(".crew-left");
const rightBtn = document.querySelector(".crew-right");

let crewIndex = 0;
let crewAnimating = false;

/*Auto play Slider start*/ 
let crewAutoPlay = setInterval(() => {
  updateCrewCarousel(crewIndex + 1);
}, 4000); // change 3000 to any delay you want (ms)
/* Auto Play Slider end*/

function updateCrewCarousel(newIndex) {
  if (crewAnimating) return;
  crewAnimating = true;

  crewIndex = (newIndex + crewCards.length) % crewCards.length;

  crewCards.forEach((card, i) => {
    const offset = (i - crewIndex + crewCards.length) % crewCards.length;
    card.classList.remove("center", "left-1", "left-2", "right-1", "right-2", "hidden");

    if (offset === 0) card.classList.add("center");
    else if (offset === 1) card.classList.add("right-1");
    else if (offset === 2) card.classList.add("right-2");
    else if (offset === crewCards.length - 1) card.classList.add("left-1");
    else if (offset === crewCards.length - 2) card.classList.add("left-2");
    else card.classList.add("hidden");
  });

  crewDots.forEach((dot, i) => {
    dot.classList.toggle("active", i === crewIndex);
  });

  // crewName.style.opacity = "0";
  // crewRole.style.opacity = "0";

  // setTimeout(() => {
  //   crewName.textContent = crewMembers[crewIndex].name;
  //   crewRole.textContent = crewMembers[crewIndex].role;
  //   crewName.style.opacity = "1";
  //   crewRole.style.opacity = "1";
  // }, 300);

  setTimeout(() => {
    crewAnimating = false;
  }, 800);
}

leftBtn.addEventListener("click", () => updateCrewCarousel(crewIndex - 1));
rightBtn.addEventListener("click", () => updateCrewCarousel(crewIndex + 1));
crewDots.forEach((dot, i) => dot.addEventListener("click", () => updateCrewCarousel(i)));
crewCards.forEach((card, i) => card.addEventListener("click", () => updateCrewCarousel(i)));

document.addEventListener("keydown", (e) => {
  if (e.key === "ArrowLeft") updateCrewCarousel(crewIndex - 1);
  else if (e.key === "ArrowRight") updateCrewCarousel(crewIndex + 1);
});

let touchStart = 0;
let touchEnd = 0;

document.addEventListener("touchstart", (e) => {
  touchStart = e.changedTouches[0].screenX;
});
document.addEventListener("touchend", (e) => {
  touchEnd = e.changedTouches[0].screenX;
  const diff = touchStart - touchEnd;
  if (Math.abs(diff) > 50) {
    if (diff > 0) updateCrewCarousel(crewIndex + 1);
    else updateCrewCarousel(crewIndex - 1);
  }
});

updateCrewCarousel(0);
